/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons/index.js";
import {
  resetInternalTransactionApprove,
  resetInternalTransactionReject,
} from "../../../../redux/features/transactions/internalTransactions/index.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import useMultiSelect from "../../../../utils/useMultiSelect.js";
import CardContainer from "../../../_utils/CommonViewAllCard/CardContainer";
import AccountNumberWithBank from "../../../_utils/CommonViewAllCard/CardSubComponent/AccountNumberWithBank/index.jsx";
import TextWithCTA from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithCTA";
import TextWithIcon from "../../../_utils/CommonViewAllCard/CardSubComponent/TextWithIcon";

const InternalTransactionMultiApprovalCard = ({
  filterOpen,
  data,
  setselectAllCard,
  selectedTransactions,
  setSelectedSendTransactions,
  selectedSendTransactions,
  setTxnId,
  openMultiTxnDetailModal,
  SetInternalAccountid,
  internalAccDetailOpen,
  setInternalAccDetailOpen,
  filterRef,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [accountData, setAccountData] = useState([]);

  const { handleSingleSelect: handleMultiSingleSelect } = useMultiSelect();
  const services = useSelector((state) => state.refreshToken.services);

  const {
    internalTransactionsApproveError,
    internalTransactionsRejectError,
    internalTransactionsDetailsData,
  } = useSelector((state) => state.internalTransactions);

  useEffect(() => {
    dispatch(resetInternalTransactionApprove());
    dispatch(resetInternalTransactionReject());
  }, [internalTransactionsApproveError, internalTransactionsRejectError]);

  const internalTxnData = internalTransactionsDetailsData?.transaction[0];

  useEffect(() => {
    setAccountData({
      ...accountData,
      owner_account_balance_last_fetched_at_in_words:
        internalTxnData?.owner_account_balance_last_fetched_at_in_words,
      owner_account_balance: internalTxnData?.owner_account_balance,
      owner_account_balance_last_fetched_at:
        internalTxnData?.owner_account_balance_last_fetched_at,
    });
  }, [internalTransactionsDetailsData]);

  const getStatusColor = (status) => {
    switch (status) {
      case "pending":
        return "var(--pending)";
      case "approved":
        return "var(--settled)";
      case "denied":
      case "blocked":
        return "var(--failed)";
      case "archived":
        return "var(--abandoned)";
      default:
        return "var(--settled)";
    }
  };

  const SideDrawerOpen = async (id, txnId) => {
    SetInternalAccountid(id);
    setInternalAccDetailOpen(!internalAccDetailOpen);
  };

  const handleCardClick = (transaction) => {
    if (transaction?.internal_account_approval_status === "approved") {
      setselectAllCard(false);
      handleMultiSingleSelect(
        selectedSendTransactions,
        setSelectedSendTransactions,
        PaginationConfiguration.paginationSmall,
        { ...transaction, id: transaction?.txn_id },
      );
    }
  };

  return (
    <>
      <div
        className={`standard-card-alignment gap-x-gap-sm gap-y-gap-md ${filterOpen && "pointer-events-none"}`}
      >
        {data?.map((transaction) => {
          return (
            <CardContainer
              filterRef={filterRef}
              varaint="overlay"
              hoverHeight={
                GlobalConfiguration?.internalTxnMultiApprovalCardHoverHeight
              }
              isDisabled={
                filterOpen ||
                transaction.internal_account_approval_status === "pending"
                  ? true
                  : false
              }
              key={transaction?.txn_id}
              isSelected={selectedTransactions.includes(transaction.txn_id)}
              onClickHandler={(e) => {
                if (
                  transaction?.internal_account_approval_status === "pending"
                ) {
                  SideDrawerOpen(
                    transaction?.internal_account_id,
                    transaction?.txn_id,
                  );
                } else {
                  handleCardClick(transaction);
                }
              }}
            >
              <card-body>
                <TextWithIcon
                  type={
                    transaction.internal_account_approval_status === "pending"
                      ? "Text"
                      : "Amount"
                  }
                  fontWeight={"semibold"}
                  text={
                    transaction.internal_account_approval_status === "pending"
                      ? "Account approval pending"
                      : transaction?.amount
                  }
                  subText={
                    transaction.internal_account_approval_status === "pending"
                      ? "Account status"
                      : "Amount"
                  }
                  textColor={getStatusColor(
                    transaction.internal_account_approval_status,
                  )}
                  iconComponentArray={
                    transaction.internal_account_approval_status !== "pending"
                      ? [
                          ...(transaction?.confidential_transaction === "Y"
                            ? [
                                {
                                  icon: ICONS?.CONFIDENTIAL_TRANSACTION,
                                  title: "confidential",
                                  isDisabled: false,
                                },
                              ]
                            : []),

                          {
                            icon: selectedTransactions.includes(
                              transaction?.txn_id,
                            )
                              ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                              : ICONS?.SELECT_ALL_WITH_WHITE_OUTLINE_CIRCLE,
                            isDisabled: false,
                          },
                        ]
                      : []
                  }
                />
                <AccountNumberWithBank
                  sourceAccNo={transaction?.owner_account_bank_acc_no}
                  destinationAccNo={transaction?.internal_account_bank_acc_no}
                  destinationIfsc={transaction?.internal_account_ifsc_code}
                  sourceIfsc={transaction?.owner_account_ifsc_code}
                />
                <TextWithCTA
                  btnText={
                    transaction.internal_account_approval_status === "pending"
                      ? "Approve account"
                      : "Additional details"
                  }
                  enabledBgColor={"var(--text-primary)"}
                  enabledTextColor={"var(--primary-bg)"}
                  handleFunction={(e) => {
                    e.stopPropagation();
                    setAccountData(transaction);
                    if (!sessionStorage?.getItem("q2p_token")) {
                      setInternalAccDetailOpen(false);

                      return;
                    }
                    if (
                      transaction?.internal_account_approval_status ===
                      "pending"
                    ) {
                      if (
                        (services?.includes("IVAccount") &&
                          services?.includes("IAAccount")) ||
                        services?.includes("Admin")
                      ) {
                        SideDrawerOpen(
                          transaction?.internal_account_id,
                          transaction?.txn_id,
                        );
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "IAAccount, IVAccount, Admin",
                          },
                        });
                      }
                      return;
                    }
                    if (
                      (services?.includes("IVAccount") &&
                        services?.includes("IAAccount")) ||
                      services?.includes("Admin")
                    ) {
                      openMultiTxnDetailModal();
                      setTxnId(transaction?.txn_id);
                    } else {
                      navigate("/feature_not_assigned", {
                        state: {
                          unavailableService: "IAAccount, IVAccount, Admin",
                        },
                      });
                    }
                  }}
                  icon={ICONS?.ARROW_RIGHT_WHITE}
                  isDisabled={
                    !(
                      transaction?.internal_account_approval_status ===
                        "pending" ||
                      transaction?.internal_account_approval_status ===
                        "approved"
                    )
                  }
                  text={
                    transaction.created_on
                      ? formatDateViewAll(transaction.created_on, false, false)
                      : "Not given"
                  }
                  subText="Date"
                />
              </card-body>
              <card-hover>
                <TextWithIcon
                  text={transaction?.labels?.join(", ") || "Not assigned"}
                  fontWeight={"normal"}
                  textColor={"var(--text-primary)"}
                  iconComponentArray={[
                    {
                      icon: ICONS?.LABEL,
                    },
                  ]}
                />
              </card-hover>
            </CardContainer>
          );
        })}
      </div>
    </>
  );
};

export default InternalTransactionMultiApprovalCard;
